<div class="component-container">
  <section class="component-header">
    <h2>Assignments</h2>
  </section>

  <ng-container *ngIf="page.totalItems === 0">
    <div class="add-data-display">

      <p>No data</p>
      <a [routerLink]="['/assign-moves']">Assign moves</a>
    </div>
  </ng-container>

  <ng-container [ngSwitch]="viewMode">


    <div class="view-moves-list" *ngSwitchCase="'movesList'">

      <section class="moves-list" *ngFor="let move of page.data">
        <div class="location-card">
          <div class="card-header">
            <div class="location-title">
              <h3><strong>Start: </strong>{{ move.start.location }}</h3>

              <mat-icon>arrow_forward</mat-icon>

              <h3><strong>End: </strong>{{ move.end.location }}</h3>
            </div>
          </div>
          <div class="objects-section">
            <section class="icon-holder">
              <mat-icon [ngStyle]="setTruckStatus(move)" class="truck-status">local_shipping</mat-icon>
            </section>
            <section class="trailer-info">
              <h3>Trailer Info</h3>

              <p class="item-info">
                <strong>Trailer: </strong>{{ move?.start?.trailer?.trailer }}
              </p>
              <p class="item-info">
                <strong>Carrier: </strong>{{ move?.start?.trailer?.carrier }}
              </p>
              <p class="item-info">
                <strong>Status: </strong>{{ move?.start?.trailer?.status }}
              </p>
            </section>
            <section class="item-buttons">
              <button mat-fab color="primary" (click)="viewMove(move)" matTooltip="View">
                <mat-icon>preview</mat-icon>
              </button>
            </section>
          </div>
        </div>
      </section>
      <mat-paginator #paginator *ngIf="page?.data?.length !== 0" (page)="handlePageEvent($event)"
        [length]="page.totalItems" [pageSize]="pageSize" [showFirstLastButtons]="true"
        [pageSizeOptions]="pageSizeOptions" [pageIndex]="page.currentPage" aria-label="Select page">
      </mat-paginator>
    </div>

    <div class="view-moves-list" *ngSwitchCase="'moveView'">
      <section class="moves-list">
        <div class="location-card">
          <div class="card-header">
            <div class="location-title">
              <h3><strong>Start: </strong> {{ selectedMove.start.location }}</h3>
              <mat-icon>arrow_forward</mat-icon>
              <h3><strong>End: </strong>{{ selectedMove.end.location }}</h3>
            </div>
          </div>
          <div class="objects-section">
            <section class="move-info">
              <section class="info-wrapper">
                <h2>Trailer Info</h2>
                <p>
                  <strong>Trailer: </strong>

                  {{ selectedMove?.start?.trailer?.trailer ?? "no data" }}
                </p>
                <p>
                  <strong>Carrier: </strong>

                  {{ selectedMove?.start?.trailer?.carrier ?? "no data" }}
                </p>
                <p>
                  <strong>Status: </strong>

                  {{ selectedMove?.start?.status ?? "no data" }}
                </p>
              </section>
            </section>
            <section class="item-buttons">
              <button mat-fab color="accent" (click)="redirectMode()" matTooltip="Redirect">
                <mat-icon>edit</mat-icon>
              </button>
              <span class="item-btn-spacer"></span>
              <button mat-fab color="primary" (click)="markAsComplete()" matTooltip="Mark as complete">
                <mat-icon>done</mat-icon>
              </button>
              <span class="item-btn-spacer"></span>
              <button mat-fab color="warn" (click)="viewMoves()" matTooltip="Back">
                <mat-icon>undo</mat-icon>
              </button>
            </section>
          </div>
        </div>
      </section>
    </div>


    <div *ngSwitchCase="'redirectMode'" class="view-moves-list">
      <h3>Move Redirect</h3>

      <section class="moves-list" *ngFor="let yard of openYardSpots">
        <div class="location-card">
          <div class="card-header">
            <div class="location-title">
              <h3><strong>Location: </strong>{{ yard.location }}</h3>
              <h3><strong>Status: </strong>{{ yard.status }}</h3>
            </div>
          </div>
          <div class="objects-section">
            <section class="item-buttons">
              <button mat-fab color="primary" (click)="redirectMove(yard)" matTooltip="Redirect">
                <mat-icon>sync</mat-icon>
              </button>
              <span class="item-btn-spacer"></span>

              <button mat-fab color="warn" (click)="bckToViewMode()" matTooltip="Back">
                <mat-icon>undo</mat-icon>
              </button>
            </section>
          </div>
        </div>
      </section>

    </div>

  </ng-container>
</div>